module.exports = __webpack_public_path__ + "static/img/20240104-163236.86cb384.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20240104-163236.png
// module id = mVM7
// module chunks = 12